"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configPortfolioTheme = exports["default"] = exports.portfolioDarkColor = exports.portfolioLightColor = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Wherever possible, pass these variables into styled components as props
// and avoid hard coding CSS values for consistent and maintainable design.
// ex. color: ${props => props.pxTheme.primaryColor};
// https://www.styled-components.com/docs/advanced#theming
var color = {
  black: '#000',
  white: '#FFF',
  lightGrey: '#EEEFF2',
  lighterGrey: '#F7F8FA',
  grey: '#D7D8DB',
  mediumGrey: '#6D7378',
  darkGrey: '#525558',
  veryDarkGrey: '#222222',
  disabledGrey: '#B6B9BB',
  alternativeGrey: '#DDDDE0',
  lightBorderGrey: '#EAEAEA',
  primaryBlue: '#0870D1',
  primaryBlueHover: '#2986F7',
  primaryBluePressed: '#0E4C99',
  accentFill: '#7FC1FF',
  accentFillLight: '#EDF6FE',
  positiveGreen: '#3D8459',
  positiveOnVDG: '#64E296',
  negative: '#EB0000',
  negativeRed: '#DB3838',
  negativeOnVDG: '#FF4848',
  negativeRedHover: '#ED2626',
  negativeRedPressed: '#DB3838',
  notificationRed: '#ff4c4c',
  raspberryRed: '#C22B3F',
  purple: '#45457c',
  teal: '#07D3D4',
  orange: '#E06F31',
  yellow: '#FDBB4D',
  brightBlue: '#4A90E2',
  brightRed: '#BF0D49',
  brightYellow: '#FEDF46',
  brightGreen: '#19D6C0',
  brightGreen2: '#CCEBDB',
  darkGreen: '#1D663A',
  adobeRed: '#c41e26',
  darkRaspberry: '#BC3750',
  darkRaspberry2: '#AF375B',
  lightRaspberry: '#E26F88',
  darkYellow: '#fccc00',
  darkTeal: '#07D3D4',
  darkTeal2: '#027A95',
  darkTeal3: '#075061',
  lightTeal: '#0CEFE8',
  lightTeal2: '#DDFFF2',
  lightPurple: '#AEAEFF',
  lightYellow: '#FEDF46',
  lightYellow2: '#FFDD66',
  lightYellow3: '#FFFDB6',
  darkPurple: '#45457C',
  warning: '#DB3838',
  babyPink: '#FFE8DC',
  navyBlue: '#2C3D63',
  lightBlue: '#EDF6FE',
  facebookBlue: '#3C5A96',
  facebookBlueHover: '#29487d',
  darkerGreen: '#094656',
  lighterBlue: '#74b9ff',
  transparent: 'transparent',
  // To add alpha to a color, pass the name of a color in theme.js and an opacity from 0 to 1
  withAlpha: function withAlpha(hexColorName, opacity) {
    // eslint-disable-next-line max-len
    if (typeof opacity !== 'number' || opacity > 1 || opacity < 0) throw new Error('opacity must be a number from 0 to 1!');
    if (!Object.keys(this).includes(hexColorName)) throw new Error('hexColorName must be a color in theme.js');
    return this[hexColorName] + Math.round(opacity * 255).toString(16).toUpperCase();
  }
};
var portfolioLightColor = {
  // portfolio light mode
  portfolioForeground1: '#1C1C1C',
  portfolioForeground2: '#707070',
  portfolioBackground1: '#FFFFFF',
  portfolioBackground2: '#F4F4F4',
  portfolioBorder: '#D7D7D7',
  portfolioAccentOrange: '#B46101',
  portfolioAccentGold: '#9E6B33',
  portfolioAccentTeal: '#2C7B76',
  portfolioAccentBlue: '#1962FF',
  portfolioAccentViolet: '#5D67ED',
  portfolioAccentAsh: '#81746E',
  portfolioAccentMono: '#383838'
};
exports.portfolioLightColor = portfolioLightColor;
var portfolioDarkColor = {
  // portfolio dark mode
  portfolioForeground1: '#FFFFFF',
  portfolioForeground2: '#979797',
  portfolioBackground1: '#1C1C1C',
  portfolioBackground2: '#303030',
  portfolioBorder: '#575757',
  portfolioAccentOrange: '#C76C01',
  portfolioAccentGold: '#C78A46',
  portfolioAccentTeal: '#3DADA5',
  portfolioAccentBlue: '#5D91FF',
  portfolioAccentViolet: '#8189FF',
  portfolioAccentAsh: '#AA9B93',
  portfolioAccentMono: '#A7A7A7'
};
exports.portfolioDarkColor = portfolioDarkColor;
var palette = {
  // Color: Hierarchy (Brand Colours)
  primaryColor: "".concat(color.primaryBlue),
  primaryColorHover: "".concat(color.primaryBlueHover),
  primaryColorActive: "".concat(color.primaryBlueHover),
  disabledColor: "".concat(color.grey),
  warningColor: "".concat(color.negativeRed),
  warningColorHover: "".concat(color.negativeRedHover),
  positiveColor: "".concat(color.positiveGreen)
};
var styles = {
  // Responsive breakpoints
  responsiveSmall: 415,
  responsiveSmallXl: 475,
  responsiveMedium: 768,
  responsiveTopnavMobile: 855,
  responsiveLarge: 1024,
  responsivePortfolioDesktop: 1152,
  responsiveLargeXl: 1280,
  responsiveDesktop: 1440,
  responsiveDesktopXl: 1920,
  // Portfolio Responsive breakpoints
  responsivePortfolioMedium: 992,
  responsivePortfolioLarge: 1088,
  // Feature Labels
  newLabelColor: '#4F815D',
  betaLabelColor: '#91C4F2',
  // Membership Tiers
  awesomeColor: "".concat(palette.primaryColor),
  awesomeColorTint: "".concat(color.primaryColorHover),
  proColor: '#B69F32',
  proColorTint: '#C5AE42',
  proPlusColor: '#111111',
  proPlusColorTint: '#111111',
  // Background
  bgColor: "".concat(color.white),
  bgColorSecondary: "".concat(color.lighterGrey),
  bgColorDark: "".concat(color.veryDarkGrey),
  bgColorActive: "".concat(color.lighterGrey),
  bgColorTint: "".concat(color.lightGrey),
  bgColorNotification: "".concat(color.lighterGrey),
  bgColorError: "".concat(color.negativeRed),
  bgColorErrorHover: "".concat(color.negativeRed),
  bgColorPositive: "".concat(color.positiveGreen),
  bgColorPositiveHover: "".concat(color.positiveGreen),
  bgColorNegative: "".concat(color.veryDarkGrey),
  bgColorPlaceholder: "".concat(color.grey),
  bgColorDarkMask: 'rgba(0, 0, 0, 0.4)',
  bgColorTooltip: "".concat(color.white),
  bgColorFeatureTooltip: "".concat(palette.primaryColor),
  bgColorMenuHover: "".concat(palette.primaryColor),
  bgColorTabFocus: 'rgba(8, 112, 209, 0.2)',
  // 20% primaryBlue
  // Font
  fontFamilyDefault: '\'Helvetica Neue\', HelveticaNeue, Helvetica, FreeSans, Arial, sansserif',
  fontFamilyInter: 'Inter',
  fontFamilyAleo: 'Aleo',
  fontFamilyPtSerif: 'PT Serif',
  fontColorDefault: "".concat(color.veryDarkGrey),
  fontColorDark: "".concat(color.veryDarkGrey),
  fontColorMediumDark: "".concat(color.grey),
  fontColorMedium: "".concat(color.mediumGrey),
  fontColorLight: "".concat(color.lightGrey),
  fontColorActive: "".concat(palette.primaryColor),
  fontColorInverted: "".concat(color.white),
  fontColorWhite: "".concat(color.white),
  fontColorWarning: "".concat(palette.warningColor),
  fontColorPositive: "".concat(palette.positiveColor),
  // Font sizing
  fontSizeHeadline: '48px',
  fontSizeHeadlineMobile: '36px',
  fontSizeHeadingLarge: '36px',
  fontSizeHeadingPortfolio: '28px',
  // portfolio HeadingLarge
  fontSizeHeadingMedium: '24px',
  fontSizeHeadingSmall: '21px',
  fontSizeBodyLarge: '18px',
  fontSizeBody: '16px',
  fontSizeBodySmall: '14px',
  fontSizeBodyXSmall: '12px',
  fontSizeCaption: '12px',
  fontSizePortfolioBodyLarge: '18px',
  // portfolio
  fontSizePortfolioBody: '16px',
  // portfolio
  fontSizePortfolioBodySmall: '14px',
  // portfolio
  fontSizeLogo: '22px',
  fontSizeLogoLarge: '28px',
  lineHeightHeadline: '52px',
  lineHeightHeadlineMobile: '40px',
  lineHeightHeadingLarge: '40px',
  lineHeightHeadingPortfolio: '32px',
  // portfolio HeadingLarge
  lineHeightHeadingMedium: '28px',
  lineHeightHeadingSmall: '24px',
  lineHeightBodyLarge: '24px',
  lineHeightBody: '20px',
  lineHeightBodySmall: '20px',
  lineHeightBodyXSmall: '16px',
  lineHeightCaption: '16px',
  lineHeightPortfolioBodyLarge: '28px',
  // portfolio
  lineHeightPortfolioBody: '24px',
  // portfolio
  lineHeightPortfolioBodySmall: '20px',
  // portfolio
  lineHeightLogo: '28px',
  lineHeightLogoLarge: '32px',
  // Old, in case it's used somewhere
  fontSizeHeadingLg: '36px',
  fontSizeHeadingMd: '24px',
  fontSizeHeadingMdMobile: '21px',
  fontSizeHeadingSm: '18px',
  fontSizeHeadingSmMobile: '16px',
  fontSizeBodySm: '16px',
  fontSizeBodySmMobile: '14px',
  letterSpacingLg: '0.2px',
  letterSpacingMd: '0px',
  letterSpacingSm: '-0.2px',
  letterSpacingXs: '-0.4px',
  // Link
  linkColorDefault: "".concat(palette.primaryColor),
  linkColorHover: "".concat(palette.primaryColorHover),
  linkColorActive: "".concat(palette.primaryColorActive),
  linkColorWarning: "".concat(palette.warningColor),
  // LikeButton Heart SVG
  heartColorOutlineHover: "".concat(color.raspberryRed),
  heartColorLikedHover: "".concat(color.veryDarkGrey),
  // SVG Icons
  iconColorDefault: "".concat(color.veryDarkGrey),
  iconColorHover: "".concat(palette.primaryColor),
  iconColorDisabled: "".concat(palette.disabledColor),
  iconColorWhite: "".concat(color.lightGrey),
  iconXl: '64px',
  iconLg: '32px',
  iconMd: '24px',
  iconSm: '16px',
  // New icon sizes
  iconSizeXs: '16px',
  iconSizeSm: '24px',
  iconSizeMd: '32px',
  iconSizeMd2: '40px',
  iconSizeLg: '48px',
  iconSizeXl: '64px',
  iconHover: 'rgba(34, 34, 34, 0.1)',
  iconFocus: 'rgba(8, 112, 209, 0.2)',
  iconActive: 'rgba(34, 34, 34, 0.2)',
  iconLightHover: 'rgba(255, 255, 255, 0.2)',
  iconLightFocus: 'rgba(8, 112, 209, 0.3)',
  iconLightActive: 'rgba(34, 34, 34, 0.2)',
  notificationBadgeSize: '56px',
  // Legacy topnav
  fontSizeTopnav: '14px',
  linkColorTopnav: "".concat(color.veryDarkGrey),
  topNavHeight: '72px',
  topNavMobileHeight: '113px',
  // Form
  formLabelFontColor: "".concat(color.mediumGrey),
  formInputFontColor: "".concat(color.veryDarkGrey),
  formErrorFontColor: "".concat(palette.warningColor),
  formActiveColor: "".concat(palette.primaryColor),
  formErrorColor: "".concat(palette.warningColor),
  formInputMaxWidth: '512px',
  formInputHeight: '44px',
  // Spacing
  spacingXxs: '4px',
  spacingXs: '8px',
  spacingSm: '16px',
  spacingMd: '24px',
  spacingLg: '32px',
  spacingXl: '64px',
  spacingXxl: '128px',
  screenMaxWidth: '1440px',
  // Borders
  borderDefault: "1px solid ".concat(color.grey),
  borderStrokeThicker: '4px',
  borderStrokeThick: '2px',
  borderStrokeThin: '1px',
  borderRadiusLg: '16px',
  borderRadiusMd: '8px',
  borderRadiusSm: '4px',
  borderColorDefault: "".concat(color.grey),
  borderColorLight: "".concat(color.grey),
  borderColorDark: "".concat(color.mediumGrey),
  borderColorFocus: "".concat(palette.primaryColorHover),
  borderWarningColor: "".concat(palette.warningColor),
  borderColorWhite: "".concat(color.white),
  // Buttons
  buttonFontSize: '16px',
  buttonLineHeight: '20px',
  buttonBorderRadius: '28px',
  // Primary
  buttonPrimaryColor: "".concat(color.primaryBlue),
  buttonPrimaryColorHover: "".concat(color.primaryBlueHover),
  buttonPrimaryColorFocus: '#529BDF',
  buttonPrimaryColorActive: '#0D60AE',
  buttonPrimaryBorderColor: "".concat(color.primaryBlue),
  buttonPrimaryBorderColorHover: "".concat(color.primaryBlueHover),
  buttonPrimaryBorderColorFocus: '#529BDF',
  buttonPrimaryBorderColorActive: '#0D60AE',
  buttonPrimaryTextColor: "".concat(color.white),
  buttonPrimaryTextColorHover: "".concat(color.white),
  buttonPrimaryTextColorFocus: "".concat(color.white),
  buttonPrimaryTextColorActive: "".concat(color.white),
  // Black
  buttonPrimaryBlackColor: "".concat(color.veryDarkGrey),
  buttonPrimaryBlackColorHover: '#4E4E4E',
  buttonPrimaryBlackColorFocus: '#1A3956',
  buttonPrimaryBlackColorActive: "".concat(color.veryDarkGrey),
  buttonPrimaryBlackBorderColor: "".concat(color.veryDarkGrey),
  buttonPrimaryBlackBorderColorHover: '#4E4E4E',
  buttonPrimaryBlackBorderColorFocus: '#1A3956',
  buttonPrimaryBlackBorderColorActive: "".concat(color.veryDarkGrey),
  buttonPrimaryBlackTextColor: "".concat(color.white),
  buttonPrimaryBlackTextColorHover: "".concat(color.white),
  buttonPrimaryBlackTextColorFocus: "".concat(color.white),
  buttonPrimaryBlackTextColorActive: "".concat(color.white),
  // White
  buttonPrimaryWhiteColor: "".concat(color.white),
  buttonPrimaryWhiteColorHover: '#E9E9E9',
  buttonPrimaryWhiteColorFocus: '#CEE2F6',
  buttonPrimaryWhiteColorActive: '#D3D3D3',
  buttonPrimaryWhiteBorderColor: "".concat(color.white),
  buttonPrimaryWhiteBorderColorHover: '#E9E9E9',
  buttonPrimaryWhiteBorderColorFocus: '#CEE2F6',
  buttonPrimaryWhiteBorderColorActive: '#D3D3D3',
  buttonPrimaryWhiteTextColor: "".concat(color.veryDarkGrey),
  buttonPrimaryWhiteTextColorHover: "".concat(color.veryDarkGrey),
  buttonPrimaryWhiteTextColorFocus: "".concat(color.veryDarkGrey),
  buttonPrimaryWhiteTextColorActive: "".concat(color.veryDarkGrey),
  // Danger
  buttonPrimaryDangerColor: "".concat(color.negativeRed),
  buttonPrimaryDangerColorHover: "".concat(color.negativeRedHover),
  buttonPrimaryDangerColorFocus: "".concat(color.negative),
  buttonPrimaryDangerColorActive: "".concat(color.negativeRedPressed),
  buttonPrimaryDangerBorderColor: "".concat(color.negativeRed),
  buttonPrimaryDangerBorderColorHover: "".concat(color.negativeRedHover),
  buttonPrimaryDangerBorderColorFocus: "".concat(color.negative),
  buttonPrimaryDangerBorderColorActive: "".concat(color.negativeRedPressed),
  buttonPrimaryDangerTextColor: "".concat(color.white),
  buttonPrimaryDangerTextColorHover: "".concat(color.white),
  buttonPrimaryDangerTextColorFocus: "".concat(color.white),
  buttonPrimaryDangerTextColorActive: "".concat(color.white),
  // Disabled
  buttonColorDisabled: "".concat(color.disabledGrey),
  // Secondary
  buttonSecondaryColor: "".concat(color.white),
  buttonSecondaryColorHover: '#E9E9E9',
  buttonSecondaryColorFocus: '#CEE2F6',
  buttonSecondaryColorActive: '#D3D3D3',
  buttonSecondaryBorderColor: "".concat(color.primaryBlue),
  buttonSecondaryBorderColorHover: "".concat(color.primaryBlue),
  buttonSecondaryBorderColorFocus: "".concat(color.primaryBlue),
  buttonSecondaryBorderColorActive: '#0D60AE',
  buttonSecondaryTextColor: "".concat(color.primaryBlue),
  buttonSecondaryTextColorHover: "".concat(color.primaryBlue),
  buttonSecondaryTextColorFocus: "".concat(color.primaryBlue),
  buttonSecondaryTextColorActive: '#0D60AE',
  // Black
  buttonSecondaryBlackColor: "".concat(color.white),
  buttonSecondaryBlackColorHover: '#E9E9E9',
  buttonSecondaryBlackColorFocus: '#C8DCF2',
  buttonSecondaryBlackColorActive: '#D3D3D3',
  buttonSecondaryBlackBorderColor: "".concat(color.veryDarkGrey),
  buttonSecondaryBlackBorderColorHover: "".concat(color.veryDarkGrey),
  buttonSecondaryBlackBorderColorFocus: "".concat(color.veryDarkGrey),
  buttonSecondaryBlackBorderColorActive: "".concat(color.veryDarkGrey),
  buttonSecondaryBlackTextColor: "".concat(color.veryDarkGrey),
  buttonSecondaryBlackTextColorHover: "".concat(color.veryDarkGrey),
  buttonSecondaryBlackTextColorFocus: "".concat(color.veryDarkGrey),
  buttonSecondaryBlackTextColorActive: "".concat(color.veryDarkGrey),
  // Hollow
  buttonSecondaryHollowColor: "".concat(color.veryDarkGrey),
  buttonSecondaryHollowColorHover: '#4E4E4E',
  buttonSecondaryHollowColorFocus: '#1A3A57',
  buttonSecondaryHollowColorActive: "".concat(color.veryDarkGrey),
  buttonSecondaryHollowBorderColor: "".concat(color.white),
  buttonSecondaryHollowBorderColorHover: "".concat(color.white),
  buttonSecondaryHollowBorderColorFocus: "".concat(color.white),
  buttonSecondaryHollowBorderColorActive: "".concat(color.white),
  buttonSecondaryHollowTextColor: "".concat(color.white),
  buttonSecondaryHollowTextColorHover: "".concat(color.white),
  buttonSecondaryHollowTextColorFocus: '#B5D4F1',
  buttonSecondaryHollowTextColorActive: '#D3D3D3',
  // Danger
  buttonSecondaryDangerColor: "".concat(color.white),
  buttonSecondaryDangerColorHover: '#E9E9E9',
  buttonSecondaryDangerColorFocus: '#CEE2F6',
  buttonSecondaryDangerColorActive: '#D3D3D3',
  buttonSecondaryDangerBorderColor: "".concat(color.negativeRed),
  buttonSecondaryDangerBorderColorHover: "".concat(color.negativeRedHover),
  buttonSecondaryDangerBorderColorFocus: "".concat(color.negative),
  buttonSecondaryDangerBorderColorActive: "".concat(color.negativeRedPressed),
  buttonSecondaryDangerTextColor: "".concat(color.negativeRed),
  buttonSecondaryDangerTextColorHover: "".concat(color.negativeRedHover),
  buttonSecondaryDangerTextColorFocus: "".concat(color.negative),
  buttonSecondaryDangerTextColorActive: "".concat(color.negativeRedPressed),
  // Tertiary
  buttonTertiaryBorderRadius: '0',
  buttonTertiaryColor: "".concat(color.transparent),
  buttonTertiaryColorHover: "".concat(color.transparent),
  buttonTertiaryColorFocus: '#C8DCF2',
  buttonTertiaryColorActive: "".concat(color.transparent),
  buttonTertiaryBorderColor: "".concat(color.transparent),
  buttonTertiaryBorderColorHover: "".concat(color.transparent),
  buttonTertiaryBorderColorFocus: '#C8DCF2',
  buttonTertiaryBorderColorActive: "".concat(color.transparent),
  buttonTertiaryTextColor: "".concat(color.primaryBlue),
  buttonTertiaryTextColorHover: "".concat(color.primaryBlueHover),
  buttonTertiaryTextColorFocus: "".concat(color.primaryBlueHover),
  buttonTertiaryTextColorActive: '#25548C',
  // White
  buttonTertiaryWhiteColor: "".concat(color.transparent),
  buttonTertiaryWhiteColorHover: '#4E4E4E',
  buttonTertiaryWhiteColorFocus: '#1A3A57',
  buttonTertiaryWhiteColorActive: "".concat(color.transparent),
  buttonTertiaryWhiteBorderColor: "".concat(color.transparent),
  buttonTertiaryWhiteBorderColorHover: '#4E4E4E',
  buttonTertiaryWhiteBorderColorFocus: '#1A3A57',
  buttonTertiaryWhiteBorderColorActive: "".concat(color.transparent),
  buttonTertiaryWhiteTextColor: "".concat(color.white),
  buttonTertiaryWhiteTextColorHover: "".concat(color.white),
  buttonTertiaryWhiteTextColorFocus: '#B5D4F1',
  buttonTertiaryWhiteTextColorActive: '#D3D3D3',
  // Danger
  buttonTertiaryDangerColor: "".concat(color.transparent),
  buttonTertiaryDangerColorHover: "".concat(color.transparent),
  buttonTertiaryDangerColorFocus: '#D3D3D3',
  buttonTertiaryDangerColorActive: "".concat(color.transparent),
  buttonTertiaryDangerBorderColor: "".concat(color.transparent),
  buttonTertiaryDangerBorderColorHover: "".concat(color.transparent),
  buttonTertiaryDangerBorderColorFocus: '#D3D3D3',
  buttonTertiaryDangerBorderColorActive: "".concat(color.transparent),
  buttonTertiaryDangerTextColor: "".concat(color.negativeRed),
  buttonTertiaryDangerTextColorHover: "".concat(color.negativeRedHover),
  buttonTertiaryDangerTextColorFocus: "".concat(color.negative),
  buttonTertiaryDangerTextColorActive: "".concat(color.negativeRedPressed),
  // Navbar
  buttonNavbarColor: "".concat(color.white),
  buttonNavbarColorHover: '#E9E9E9',
  buttonNavbarColorFocus: '#C8DCF2',
  buttonNavbarColorActive: "".concat(color.veryDarkGrey),
  buttonNavbarBorderColor: "".concat(color.veryDarkGrey),
  buttonNavbarBorderColorHover: "".concat(color.veryDarkGrey),
  buttonNavbarBorderColorFocus: "".concat(color.veryDarkGrey),
  buttonNavbarBorderColorActive: '#454545',
  buttonNavbarTextColor: "".concat(color.veryDarkGrey),
  buttonNavbarTextColorHover: "".concat(color.veryDarkGrey),
  buttonNavbarTextColorFocus: "".concat(color.veryDarkGrey),
  buttonNavbarTextColorActive: "".concat(color.white),
  //
  // Old button styles
  buttonColorPrimary: "".concat(palette.primaryColor),
  buttonColorPrimaryHover: "".concat(palette.primaryColorHover),
  buttonColorSecondary: "".concat(color.white),
  buttonColorSecondaryHover: "".concat(color.white),
  buttonColorTertiary: "".concat(color.white),
  buttonColorTertiaryHover: "".concat(color.white),
  buttonColorWarning: "".concat(palette.warningColor),
  buttonColorWarningHover: "".concat(palette.warningColorHover),
  buttonColorDark: "".concat(color.veryDarkGrey),
  buttonColorDarkHover: "".concat(color.veryDarkGrey),
  buttonColorLight: "".concat(color.white),
  buttonColorLightHover: "".concat(color.white),
  buttonBorderColorPrimary: "".concat(palette.primaryColor),
  buttonBorderColorPrimaryHover: "".concat(palette.primaryColorHover),
  buttonBorderColorSecondary: "".concat(color.primaryBlue),
  buttonBorderColorSecondaryHover: "".concat(color.primaryBlue),
  buttonBorderColorTertiary: "".concat(color.grey),
  buttonBorderColorTertiaryHover: "".concat(color.grey),
  buttonBorderColorWarning: "".concat(palette.warningColor),
  buttonBorderColorWarningHover: "".concat(palette.warningColorHover),
  buttonBorderColorDark: "".concat(color.veryDarkGrey),
  buttonBorderColorDarkHover: "".concat(color.veryDarkGrey),
  buttonBorderColorLight: "".concat(color.grey),
  buttonBorderColorLightHover: "".concat(color.grey),
  buttonTextColorPrimary: "".concat(color.white),
  buttonTextColorPrimaryHover: "".concat(color.white),
  buttonTextColorSecondary: "".concat(palette.primaryColor),
  buttonTextColorSecondaryHover: "".concat(palette.primaryColorHover),
  buttonTextColorTertiary: "".concat(palette.primaryColor),
  buttonTextColorTertiaryHover: "".concat(palette.primaryColorHover),
  buttonTextWarningColor: "".concat(color.white),
  buttonTextWarningColorHover: "".concat(color.white),
  buttonTextColorDark: "".concat(color.white),
  buttonTextColorDarkHover: "".concat(color.white),
  buttonTextColorLight: "".concat(color.veryDarkGrey),
  buttonTextColorLightHover: "".concat(color.veryDarkGrey),
  closeButtonSize: '26px',
  closeButtonSizeSm: '16px',
  closeButtonColor: "".concat(color.veryDarkGrey),
  closeButtonColorHover: "".concat(palette.primaryColor),
  // Loading components
  loadingPrimaryColor: "".concat(color.lighterGrey),
  loadingSecondaryColor: "".concat(color.grey),
  // Search
  searchBorderColor: "".concat(color.lightGrey),
  searchBorderColorFocus: "".concat(palette.primaryColor),
  searchInputColor: "".concat(color.lighterGrey),
  searchInputColorFocus: "".concat(color.white),
  searchPlaceholderColor: "".concat(color.mediumGrey),
  searchFontColor: "".concat(color.veryDarkGrey),
  // Input
  inputPlaceholderColor: "".concat(color.mediumGrey),
  // Messenger
  sentMessageBackgroundColor: "".concat(color.primaryBlue),
  sentMessageColor: "".concat(color.white),
  receivedMessageBackgroundColor: "".concat(color.lighterGrey),
  receivedMessageColor: "".concat(color.veryDarkGrey),
  messageTimestampColor: "".concat(color.mediumGrey),
  chatUserMenuLinkColor: "".concat(color.darkGrey),
  chatUserMenuLinkColorHover: "".concat(color.mediumGrey),
  newMessageIndicatorColor: "".concat(color.notificationRed),
  rosterSelfPillBackgroundColor: "".concat(color.greyLightSecondary),
  // Box shadows
  boxShadowSm: '0 1px 3px rgba(0,0,0,0.16), 0 0 1px rgba(0,0,0,.08)',
  boxShadowMd: '0 2px 6px rgba(0,0,0,0.16), 0 0 2px rgba(0,0,0,.08)',
  boxShadowLg: '0 4px 12px rgba(0,0,0,0.16), 0 0 4px rgba(0,0,0,.08)',
  boxShadowXl: '0 8px 24px rgba(0,0,0,0.16), 0 0 8px rgba(0,0,0,.08)',
  boxShadowSmBottom: '0 0 1px rgba(0,0,0,.02), 0 1px 3px rgba(0,0,0,0.08)',
  boxShadowMdBottom: '0 0 2px rgba(0,0,0,.02), 0 2px 6px rgba(0,0,0,0.08)',
  boxShadowLgBottom: '0 0 4px rgba(0,0,0,.02), 0 4px 12px rgba(0,0,0,0.08)',
  boxShadowXlBottom: '0 0 8px rgba(0,0,0,.02), 0 8px 24px rgba(0,0,0,0.08)'
};
var theme = Object.assign(color, palette, styles);
var _default = theme;
exports["default"] = _default;

var configPortfolioTheme = function configPortfolioTheme(mode, fontFamily) {
  var portfolioColor = mode === 'dark' ? portfolioDarkColor : portfolioLightColor;
  return _objectSpread(_objectSpread(_objectSpread({}, theme), portfolioColor), {}, {
    portfolioFontFamily: fontFamily
  });
};

exports.configPortfolioTheme = configPortfolioTheme;